import OrganizationTransferScreen from './OrganizationTransferScreen';

export default OrganizationTransferScreen;
